import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M6 2.5h4v-1H6v1Zm8 2h-1.5v10h-9v-10H2v-1h12v1Zm-9.5 0h7v9h-7v-9Zm1.75 2v5h1v-5h-1Zm2.5 5v-5h1v5h-1Z",
		clipRule: "evenodd"
	})
});
export default SvgDelete;
